import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export const NotFound: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const isViewer = currentUser?.role === 'viewer';

  const handleBack = () => {
    if (isViewer) {
      navigate('/admin/sites');
    } else {
      navigate('/admin/dashboard');
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#F5F5F5',
        px: 2,
      }}
    >
      <Typography
        variant="h1"
        sx={{
          fontSize: '120px',
          fontWeight: 700,
          color: '#1B76D2',
          mb: 2,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        sx={{
          fontSize: '24px',
          fontWeight: 600,
          color: '#000000',
          mb: 2,
        }}
      >
        ページが見つかりません
      </Typography>
      <Typography
        variant="body1"
        sx={{
          fontSize: '16px',
          color: '#666666',
          mb: 4,
          textAlign: 'center',
        }}
      >
        お探しのページは存在しないか、アクセス権限がありません。
      </Typography>
      <Button
        variant="contained"
        onClick={handleBack}
        sx={{
          backgroundColor: '#1B76D2',
          color: '#FFFFFF',
          borderRadius: '8px',
          px: 4,
          py: 1.5,
          fontSize: '16px',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: '#0062C6',
          },
        }}
      >
        {isViewer ? 'サイト一覧に戻る' : 'ダッシュボードに戻る'}
      </Button>
    </Box>
  );
};

